module.exports = __webpack_public_path__ + "img/banner3.231fc6e8.jpg";